<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Container for authenticated users -->
    @if (isAuthenticated) {
      <div class="container">
        <!-- Display user details if authenticated and user data is fetched -->
        <div class="text-center">
          <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid mb-4"
            style="max-width: 300px;" [alt]="'accountDelete.logo' | transloco">
            <h2>{{ 'accountDelete.deleteAccount' | transloco }}</h2>
          </div>
          <div class="user-details text-center">
            <img [src]="userLogoUrl ? userLogoUrl : 'assets/images/No-Image.png'" class="rounded-circle mb-2"
              style="height: 80px; object-fit: cover;" [alt]="'accountDelete.userImage' | transloco">
              <h4>{{ firstName }}</h4>
              <p class="text-muted">{{ UserEmail }}</p>
            </div>
            @if (!isConfirmingDelete) {
              <div class="text-center">
                <button type="button" p-button class="p-button p-button-danger  p-button-outlined"  (click)="confirmDelete()"
                [disabled]="!UserEmail">{{ 'accountDelete.deleteAccount' | transloco }}</button>
                <button type="button" p-button class="p-button p-button-secondary ms-2 p-button-outlined" (click)="cancelDelete()">{{ 'accountDelete.cancel' | transloco }}</button>
              </div>
            }
            @if (isConfirmingDelete) {
              <div class="confirmation mt-4">
                <form #confirmDeleteForm="ngForm" (ngSubmit)="deleteAuthenticatedUser()">
                  <div class="form-group mb-2">
                    <label for="confirmUsername" class="form-label">{{ 'accountDelete.confirmYourUsername' | transloco }}</label>
                    <input type="text" id="confirmUsername" name="confirmUsername" [(ngModel)]="confirmUsername"
                      class="form-control" required>
                    </div>
                    <div class="form-group mb-2">
                      <label for="confirmPassword" class="form-label">{{ 'accountDelete.confirmYourPassword' | transloco }}</label>
                      <input type="password" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword"
                        class="form-control" required>
                      </div>
                      <div class="text-center">
                        <button type="submit" p-button class="p-button p-button-danger p-button-outlined"
                        [disabled]="confirmUsername !== UserEmail || !confirmPassword">{{ 'accountDelete.deleteMyAccount' | transloco }}</button>
                        <button type="button" p-button class="p-button p-secondary ms-2 p-button-outlined"
                        (click)="Backtoggle()">{{ 'accountDelete.cancel' | transloco }}</button>
                      </div>
                    </form>
                  </div>
                }
              </div>
            }

            <!-- Container for unauthenticated users -->
            <div class="row justify-content-center">
              @if (!isAuthenticated) {
                <div class="container2">
                  <div class="text-center">
                    <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid mb-4"
                      style="max-width: 300px;" [alt]="'accountDelete.logo' | transloco">
                    </div>
                    <form #usernameForm="ngForm" class="form" (ngSubmit)="verifyUnauthenticatedUsername()">
                      <h2 class="mb-4 text-center">{{ 'accountDelete.deleteAccount' | transloco }}</h2>
                      <div class="form-group mt-3">
                        <label for="confirmUsername" class="form-label">{{ 'accountDelete.enterYourUsername' | transloco }}</label>
                        <div class="input-group">
                          <input type="text" id="confirmUsername" name="confirmUsername" [(ngModel)]="confirmUsername"
                            class="form-control" required>
                            <button type="submit" class="btn btn-secondary" [disabled]="!confirmUsername">{{ 'accountDelete.verifyUsername' | transloco }}</button>
                          </div>
                        </div>
                        @if (isUsernameValid && !isConfirmingDelete && userInfo.Email) {
                          <div
                            class="user-details mt-4 text-center">
                            <div class="mb-3">
                              <img [src]="userInfo.ImgUrl ? userInfo.ImgUrl : 'assets/images/No-Image.png'"
                                class="rounded-circle" style="height: 80px; object-fit: cover;">
                              </div>
                              <h4 class="mb-2">{{ userInfo.Name }}</h4>
                              <p class="mb-4">{{ userInfo.Email }}</p>
                              <div class="form-group mb-3">
                                <input type="password" id="Password" name="Password" [placeholder]="'accountDelete.enterYourPassword' | transloco"
                                  [(ngModel)]="deleteUserInfo.Password" class="form-control" required>
                                </div>
                                <div class="form-group text-center">
                                  <button type="button" class="btn btn-danger" [disabled]="!deleteUserInfo.Password"
                                  (click)="deleteUnAuthenticated()">{{ 'accountDelete.deleteMyAccount' | transloco }}</button>
                                </div>
                              </div>
                            }
                          </form>
                        </div>
                      }
                    </div>
                  </div>
                </div>